module.exports = __webpack_public_path__ + "img/logoeco.4315443a.png";